import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import SquareTopDown from '@/images/arrows/SquareTopDown.svg';
import { useAnalytics } from '@/services/analytics';
import { MixPanelEvent } from '@/utils/types';
import { LibraryItem } from '@d-id/types';
import styled from '@emotion/styled';
import { SimpleShowAction } from './simpleshow-utils';

const ButtonOverlay = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
`;

const ActionButton = styled.button`
    background-color: ${({ theme }) => theme.colors.secondary[900]};
    display: inline-flex;
    height: 32px;
    padding: 0 12px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    color: white;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    white-space: nowrap;
    outline: none;

    &:hover {
        background-color: ${({ theme }) => theme.colors.secondary[800]};
    }

    &:focus {
        outline: none;
    }
`;

interface Props {
    action: SimpleShowAction;
    item: LibraryItem;
    origin: string;
}

export const SimpleShowActionButton = ({ action, item, origin }: Props) => {
    const mixpanel = useAnalytics();

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        mixpanel?.track(action.eventName, {
            event: MixPanelEvent.CLICK,
            from: origin,
            videoId: item.id,
            editorType: 'video-maker',
        });
        window.open(action.url, '_blank', 'noopener,noreferrer');
    };

    return (
        <ButtonOverlay>
            <ActionButton onClick={handleClick}>
                {action.text}
                <MaskedIcon src={SquareTopDown} size="16px" color="white" />
            </ActionButton>
        </ButtonOverlay>
    );
};
